import { Tree } from 'antd';
import { DirectoryTreeProps, TreeProps, AntTreeNodeProps } from 'antd/lib/tree';
import './VtxTree.scss';
import * as React from 'react';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
export {
    AntTreeNodeMouseEvent,
    AntTreeNodeExpandedEvent,
    AntTreeNodeCheckedEvent,
    AntTreeNodeSelectedEvent,
    AntdTreeNodeAttribute,
    DirectoryTreeExpandAction,
    DataNode as TreeDataNode,
} from 'antd/lib/tree';

export interface VtxTreeProps extends TreeProps, IAutomatable {}
export interface VtxDirectoryTreeProps extends DirectoryTreeProps, IAutomatable {}
export interface VtxTreeNodeProps extends AntTreeNodeProps, IAutomatable {}

export const VtxTree: FunctionComponent<VtxTreeProps> = React.memo((props: VtxTreeProps) => {
    const automationClass = 'vtx-tree';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);
    const classNamesCombined = classNames(automationClass);

    return <Tree data-automation-class={automationClass} className={classNamesCombined} {...otherProps} />;
});

export const VtxDirectoryTree: FunctionComponent<VtxDirectoryTreeProps> = React.memo(
    (props: VtxDirectoryTreeProps) => {
        const automationClass = 'vtx-tree-directory';
        const { className, ...otherProps } = preventDataAutomationOverriding(props);
        const classNamesCombined = classNames(automationClass);

        return (
            <Tree.DirectoryTree
                data-automation-class={automationClass}
                className={classNamesCombined}
                {...otherProps}
            />
        );
    }
);

export const VtxTreeNode: FunctionComponent<VtxTreeNodeProps> = React.memo((props: VtxTreeNodeProps) => {
    const vtxClassName = 'vtx-tree-node';
    const { className, ...otherProps } = preventDataAutomationOverriding(props);

    return <Tree.TreeNode className={vtxClassName} {...otherProps} />;
});
